"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TabList = void 0;
var react_1 = __importDefault(require("react"));
var tabs_1 = require("@reach/tabs");
var classnames_1 = __importDefault(require("classnames"));
var TabList_module_scss_1 = __importDefault(require("./TabList.module.scss"));
/**
 * Wrapper for the tabs themselves
 */
var TabList = function (props) {
    var ariaLabel = props["aria-label"], _a = props.noPadding, noPadding = _a === void 0 ? false : _a, children = props.children;
    return (react_1["default"].createElement(tabs_1.TabList, { "aria-label": ariaLabel, className: (0, classnames_1["default"])(TabList_module_scss_1["default"].tabList, noPadding && TabList_module_scss_1["default"].noPadding) }, children));
};
exports.TabList = TabList;
//# sourceMappingURL=TabList.js.map